<template>
    <span class="bpm-value" :class="cssClass" :title="tooltip">
        <template v-if="hasBpm">{{ bpm }}<span class="bpm-unit"> BPM</span></template>
        <template v-else>--</template>
    </span>
</template>
<script>
    // Renders a track's BPM and, for auto-detected values, tints the
    // background by detection confidence so a DJ can see at a glance which
    // numbers to trust. Values read from file metadata are shown plain (they
    // are exact), matching how a hand-entered tempo would look.
    //
    // Confidence (Instance.bpm_confidence, 0..1) buckets:
    const CONF_HIGH = 0.75  // green - estimates strongly agree
    const CONF_MID = 0.5    // yellow - some disagreement

    export default {
        name: 'bpm-value',
        props: {
            // A serialized Instance carrying bpm / bpm_source / bpm_confidence.
            instance: { type: Object, required: true }
        },
        computed: {
            bpm() {
                return this.instance.bpm
            },
            hasBpm() {
                // The list endpoint sends '--' for "no value"; the full
                // serializer sends 0. Treat both (and null) as empty.
                const v = this.bpm
                return v !== '--' && v !== 0 && v !== '0' && v !== null && v !== undefined
            },
            source() {
                return this.instance.bpm_source || ''
            },
            isDetected() {
                return this.hasBpm && this.source.startsWith('detected')
            },
            confidenceLevel() {
                if (!this.isDetected) return null
                const c = this.instance.bpm_confidence
                if (c >= CONF_HIGH) return 'high'
                if (c >= CONF_MID) return 'mid'
                return 'low'
            },
            cssClass() {
                // Metadata / legacy values get no tint - shown as-is.
                return this.confidenceLevel
                    ? `bpm-detected bpm-conf-${this.confidenceLevel}`
                    : ''
            },
            tooltip() {
                if (!this.hasBpm) return ''
                if (this.isDetected) {
                    const c = this.instance.bpm_confidence
                    const pct = (c === null || c === undefined)
                        ? '—'
                        : Math.round(c * 100) + '%'
                    return `Определён автоматически, уверенность ${pct}`
                }
                if (this.source.startsWith('metadata')) {
                    return 'Из метаданных файла'
                }
                return ''
            }
        }
    }
</script>
<style scoped>
    .bpm-value {
        white-space: nowrap;
    }
    .bpm-unit {
        opacity: 0.5;
    }
    /* Detected values are tinted by confidence; the padding/radius turn the
       tint into a small badge without disturbing table row height. */
    .bpm-detected {
        padding: 0 5px;
        border-radius: 3px;
    }
    .bpm-conf-high {
        background-color: #d4edda;
    }
    .bpm-conf-mid {
        background-color: #fff3cd;
    }
    .bpm-conf-low {
        background-color: #f8d7da;
    }
</style>
